import React from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon, LockIcon } from 'lucide-react';
export function OfferSection() {
  return <section id="oferta" className="w-full py-24 px-4 bg-brand-bg relative overflow-hidden" data-id="element-65">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-66" />

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-67">
        <div className="bg-brand-card border-2 border-brand-gold rounded-2xl p-8 md:p-12 shadow-[0_0_50px_rgba(212,168,67,0.15)]" data-id="element-68">
          <h2 className="text-4xl md:text-5xl text-brand-text mb-6" data-id="element-69">
            Toma el Control Hoy Mismo
          </h2>

          <p className="text-xl text-brand-muted mb-4 max-w-2xl mx-auto" data-id="element-70">
            Obtén el sistema completo{' '}
            <strong className="text-brand-gold font-normal" data-id="element-71">
              Método Anti-Tipster
            </strong>{' '}
            hoy mismo. Toma el control de tus finanzas deportivas y deja de ser
            el peón en el negocio de los Tipsters.
          </p>
          <p className="text-lg text-brand-text mb-10 max-w-2xl mx-auto font-medium" data-id="element-72">
            Menos de lo que pagas por{' '}
            <span className="text-brand-red" data-id="element-73">una sola apuesta</span> siguiendo a
            un Tipster. Solo que esta vez, la inversión te devuelve{' '}
            <span className="text-brand-gold" data-id="element-74">independencia para siempre</span>.
          </p>

          <div className="mb-10" data-id="element-75">
            <p className="text-brand-faint text-lg uppercase tracking-wider mb-2" data-id="element-76">
              Precio de Introducción
            </p>
            <div className="flex items-center justify-center gap-4 mb-1" data-id="element-77">
              <span className="text-3xl md:text-4xl font-bold text-brand-red font-heading line-through decoration-brand-red decoration-[3px]" data-id="element-78">
                $27 USD
              </span>
              <span className="bg-brand-red text-white text-sm md:text-base font-bold px-3 py-1 rounded-md uppercase tracking-wide" data-id="element-79">
                -76.33%
              </span>
            </div>
            <div className="text-6xl md:text-7xl font-bold text-brand-gold font-heading flex items-center justify-center gap-2" data-id="element-80">
              $6.39 <span className="text-2xl text-brand-muted mt-4" data-id="element-81">USD</span>
            </div>
          </div>

          <div className="max-w-md mx-auto space-y-4" data-id="element-82">
            <CTAButton href="https://apuestasinteligentes.com/cart/47692107743453:1" className="w-full text-xl py-5 shadow-[0_0_30px_rgba(212,168,67,0.3)]" data-id="element-83">
              QUIERO SER UN ANALISTA INDEPENDIENTE AHORA
            </CTAButton>

            <div className="flex flex-col items-center gap-2 pt-4" data-id="element-84">
              <div className="flex items-center gap-2 text-brand-muted text-sm" data-id="element-85">
                <ShieldCheckIcon className="w-4 h-4 text-brand-green" data-id="element-86" />
                <span data-id="element-87">Acceso instantáneo a la descarga del PDF</span>
              </div>
              <div className="flex items-center gap-2 text-brand-faint text-xs" data-id="element-88">
                <LockIcon className="w-3 h-3" data-id="element-89" />
                <span data-id="element-90">Pago 100% seguro y encriptado</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}